export default "__VITE_ASSET__BwokSqtb__"